<div>
  <section *ngIf="boardInfo.lvt_group == '1'" class="qna-tab">
    <div role="tabpnael">
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item mr2" [ngClass]="{w180:groupTab.length > 8}" *ngFor="let item of groupTab">
          <a data-toggle="tab" class="nav-link cp" [ngClass]="{active:params.group_id==item}" (click)="loadList(item)">{{item}}</a>
        </li>
      </ul>
    </div>
  </section>

  <table class="list-table" *ngIf="checkLoading() && params.view_type == 'list'">
    <colgroup>
      <col class="col1">
      <col class="col2">
      <col class="col3">
      <col class="col4">
    </colgroup>
    <thead>
    <tr>
      <th>{{'BOARD.HEAD1' | translate}}</th>
      <th>{{'BOARD.HEAD2' | translate}}</th>
      <th>{{'BOARD.HEAD3' | translate}}</th>
      <th>{{'BOARD.HEAD4' | translate}}</th>
    </tr>
    </thead>    
    <tbody>
      <tr *ngFor="let item of data;index as i" class="cp" [ngClass]="{important: item.is_notice===true}" (click)="view(item)">
        <td [ngClass]="{'notice': item.is_notice=='1'}">
          <span *ngIf="item.is_notice=='1'">{{'BOARD.BODY_NOTICE' | translate}}</span>
          <span *ngIf="item.is_notice!='1'">{{params.totalCount - ( ( ( params.no - 1 ) * params.row ) + i )}}</span>
        </td>
        <td class="tl">
          <ng-container *ngIf="checkReply( item ) == true">
            <span *ngFor="let col of arrayReply(item.reply_level);index as i" [ngClass]="{'reply-arrow': i > 0}"></span>
            <span class="material-icons" style="text-align:right;padding-left: 5px;">subdirectory_arrow_right</span>
          </ng-container>
          <i *ngIf="item.is_pw=='1'" class="material-icons">lock</i>
          <a class="title" [ngClass]="{'append-file': item.uploadCount > 0}"><b *ngIf="item.group_id !== ''">[{{item.group_id}}]</b> {{item.subject}}</a>
        </td>
        <td>{{item.write_date.substr(0,10)}}</td>
        <td>{{item.hit}}</td>
      </tr>
      <tr *ngIf="data.length < 1">
        <td colspan="4" class="center">{{'BOARD.BODY_NOT_DATA' | translate}}</td>
      </tr>
    </tbody>
  </table>

  <table class="list-table" *ngIf="checkLoading() && params.view_type == 'album'">
    <colgroup>
      <col style="width:300px" />
      <col />
     </colgroup>
    
    <thead>
    <tr>
       <th scope="col">이미지</th>
       <th scope="col">제목/내용</th>
    </tr>
    </thead>
    
    <tbody>
    <tr *ngFor="let row of data">
      <td class="board-img">
        <a class="cp" (click)="view(row)">
          <img *ngIf="!row.upload_file" src="/assets/admin/images/board_img.png">
          <img *ngIf="row.upload_file" [src]="baseURL + row.thumbnail">
        </a>
      </td>
      <td class="tl">
        <div class="title">
          <p class="fl form-inline">
            <a class="cp" (click)="view(row)">
              <span [innerHTML]="row.subject"></span>
            </a>
            <i *ngIf="row.uploadCount > 0" class="material-icons file-ico fl">&#xe226;</i>
            <span class="ico-firstfiber_new new-ico"></span>
          </p>
          <p class="fr mt5">{{row.writer_name}}     {{row.write_date}}     조회수 : {{row.hit}}</p>
          <div class="cb"></div>  
        </div>
        <div class="board-text">
          <!--
          {{row.contents}}
          //-->
        </div>
        <!--
        <ul class="file-ul mt15">
          <li><i class="material-icons file-ico">">&#xe226;</i> <a href="">첨부파일이름1.pptx</a></li>
          <li><i class="material-icons file-ico">&#xe226;</i> <a href="">첨부파일이름2.pptx</a></li>
        </ul>
        //-->
      </td>
    </tr>
    </tbody>
  </table>

  <ng-container *ngIf="checkLoading() && params.view_type == 'gallery'">
    <ul class="gallery-ul">
      <li *ngFor="let row of data">
        <a class="cp" (click)="view(row)">
          <ng-container *ngIf="!row.upload_file" >
            <div class="img" style="background:url('/assets/admin/images/board_img.png') no-repeat 50% 50%;background-size:inherit"></div>
          </ng-container>
          <ng-container *ngIf="row.upload_file" >
            <div *ngIf="row.upload_file" class="img" [style.backgroundImage]="'url(' + ( baseURL + row.thumbnail  ) + ')'"></div>
          </ng-container>
    
          <div class="title">
            <ng-container *ngIf="boardInfo.board_id != 'install' && boardInfo.board_id != 'gallery'">
              <p class="fl wdate">
                {{row.write_date}}
                {{row.writer_name}}
              </p>
              <p class="fr hit">조회수 : {{row.hit}}</p>
              <div class="cb"></div>
            </ng-container>
            <p class="title1">
              <span class="mt3" [innerHTML]="row.subject"></span>
              <i *ngIf="row.uploadCount > 0" class="material-icons file-ico">&#xe226;</i>
              <span class="ico-firstfiber_new new-ico"></span>
            </p>
          </div>
        </a>
      </li>
    </ul>
    
    <div class="cb"></div>
  </ng-container>

  <div class="pagination-area mt15">
    <ngb-pagination
      [(page)]="params.no"
      [pageSize]="params.row"
      [maxSize]="maxSize"
      [collectionSize]="params.totalCount"
      [boundaryLinks]="true"
      rotate="true"
      (pageChange)="loadPage($event)"
      >
      <ng-template ngbPaginationFirst>&lt;&lt;</ng-template>
      <ng-template ngbPaginationLast>&gt;&gt;</ng-template>
      <ng-template ngbPaginationPrevious>&lt;</ng-template>
      <ng-template ngbPaginationNext>&gt;</ng-template>
    </ngb-pagination>
  </div>
</div>